// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2IA-w","infoBtn":"quickbooks_infoBtn__20k66","formBox":"quickbooks_formBox__3_6bC","formFooter":"quickbooks_formFooter__88vN_"};